module.exports = __webpack_public_path__ + "static/media/link.01f67917.svg";